import { render, staticRenderFns } from "./showMoreCell.vue?vue&type=template&id=63e6120f&scoped=true"
import script from "./showMoreCell.vue?vue&type=script&lang=js"
export * from "./showMoreCell.vue?vue&type=script&lang=js"
import style0 from "./showMoreCell.vue?vue&type=style&index=0&id=63e6120f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e6120f",
  null
  
)

export default component.exports